import { customFetch } from '@skytech/auth'
import { camelizeKeys } from '@skytech/utils'

export const get = async <T>(path: string): Promise<T> => {
  const pathnameParts = window?.location?.pathname?.split('/')
  const code = pathnameParts[pathnameParts.length - 1]

  const res = await customFetch({ path: path.replace(':code', code) })
  const camelizedData = camelizeKeys(res)

  return camelizedData as T
}

export const post = async <T>(path: string, data: unknown): Promise<T> => {
  const pathnameParts = window?.location?.pathname?.split('/')
  const code = pathnameParts[pathnameParts.length - 1]

  // todo: parse to snake case automatically
  const res = await customFetch({ path: path.replace(':code', code), method: 'POST', data })
  const camelizedData = camelizeKeys(res)

  return camelizedData as T
}
